import * as styles from './CheckboxField.module.css'

import React from 'react'

import { Checkbox, Props as CheckboxProps } from './Checkbox'

interface Props extends CheckboxProps {
  label: string
}

export const CheckboxField: React.FC<Props> = (props) => {
  const { label, ...checkboxProps } = props

  return (
    <label className={styles.label}>
      <Checkbox {...checkboxProps} /> {label}
    </label>
  )
}
